import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import gycj from '../components/gycj/gycj'
import lxwm from '../components/lxwm/lxwm'
import swyszqb from '../components/ywjs/swyszqb'
import xgxcp from '../components/ywjs/xgxcp'
import xwzxhome from '../components/xwzx/xwzxhome'
import xgbd from '../components/xwzx/xgbd'
import hdjy from '../components/xwzx/hdjy'
import cgal from '../components/cgal/cgal'
import content from '../components/pub/content.vue'
import lyb from '../components/lyb/lyb'

Vue.use(Router);

export default new Router({
	mode:'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
  	  meta:{
			title:'青岛纯晶稀有元素有限公司'
	  }
    },
    {
    	path:'/gycj',
    	name:'gycj',
    	component:gycj,
    	meta:{
    		title:'关于纯晶'
    	}
    },
    {
    	path:'/swyszqb',
    	name:'swyszqb',
    	component:swyszqb,
    	meta:{
    		title:'实物元素周期表'
    	}
    },
    {
    	path:'/xgxcp',
    	name:'xgxcp',
    	component:xgxcp,
    	meta:{
    		title:'相关小产品'
    	}
    },
    {
    	path:'/lxwm',
    	name:'lxwm',
    	component:lxwm,
    	meta:{
    		title:'联系我们'
    	}
    },
    {
    	path:'/xwzxhome',
    	name:'xwzxhome',
    	component:xwzxhome,
    	meta:{
    		title:'公司新闻'
    	}
    },
    {
    	path:'/xgbd',
    	name:'xgbd',
    	component:xgbd,
    	meta:{
    		title:'相关报道'
    	}
    },
    {
    	path:'/hdjy',
    	name:'hdjy',
    	component:hdjy,
    	meta:{
    		title:'活动剪影'
    	}
    },
    {
    	path:'/cgal',
    	name:'cgal',
    	component:cgal,
    	meta:{
    		title:'成功案例'
    	}
    },
    {
    	path:'/lyb',
    	name:'lyb',
    	component:lyb,
    	meta:{
    		title:'留言板'
    	}
    },
	{
		path:'/content/:id',
		name:'content',
		component:content,
		meta:{
    		title:'内容详情'
    	}
	},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js